import React from "react";
import useLazyFetch from "../../../../hooks/useLazyFetch";
import { USER_WITHDRAWAL_DELETE } from "../../../../redux/config/links";
import { Button, Col, FormGroup, Label } from "reactstrap";
import LoadingContent from "../../../../components/LoadingContent/LoadingContent";

const WithdrawalDelete = ({ initialValues, onClose, onReload }) => {
  const [deleteUserWithDrawal, { loading }] = useLazyFetch({
    url: USER_WITHDRAWAL_DELETE,
    method: "POST",
    type: "json",
  });
  return (
    <div className="container">
      <FormGroup row>
        <Col xs="12" md="12">
          <Label htmlFor="text-input">
            Do you want to delete this Withdrawal?{" "}
          </Label>
        </Col>
      </FormGroup>
      <LoadingContent loading={loading}>
        <div>
          <Button
            onClick={() => {
              deleteUserWithDrawal({ body: {id: initialValues.id} }, () => {
                onReload();
                onClose();
              });
            }}
            size="sm"
            color="danger"
            disabled={loading}
          >
            <i className="fa fa-trash"></i> Submit
          </Button>
          <Button
            onClick={() => onClose()}
            size="sm"
            color="success"
            disabled={loading}
          >
            <i className="fa fa-window-close"></i> Close
          </Button>
        </div>
      </LoadingContent>
    </div>
  );
};

export default WithdrawalDelete;
